define([
    'mixitup'
], function(
    Mixitup
) {
    var _self,
        mixer;
    // console.log('events');

    // obj
    _self = {
        toggleFilters: function ($el) {
            var $filters = $el.siblings('.filter-list'),
                activeClass = 'filter-bar__heading--active';

            if (!$filters.length) {
                return;
            }

            $el.toggleClass(activeClass);
            $filters.toggle();
        },
        getFilterGroups: function() {
            var groupFilters = [],
                $groups = $('[data-filter-group]');
            // get active
            $groups.each(function () {
                var $group = $(this),
                    $items = $group.find('[data-list-filter]'),
                    filters = [];
                $items.each(function () {
                    var $item = $(this),
                        key = $item.attr('name');
                        value = $item.val();
                    if (value) {
                        filters.push('.' + key + '-' + value);
                    }
                });
                if (filters.length) {
                    groupFilters.push(filters);
                }
            });
            return groupFilters;
        },
        getFilterPermutations: function(arr) {
            if (arr.length === 0) {
                return [];
            } else if (arr.length === 1){
                return arr[0];
            } else {
                var result = [];
                var allCasesOfRest = _self.getFilterPermutations(arr.slice(1));  // recur with the rest of array

                for (var c in allCasesOfRest) {
                    for (var i = 0; i < arr[0].length; i++) {
                        result.push(arr[0][i] + allCasesOfRest[c]);
                    }
                }
                return result;
            }
        },
        activateMixItUp: function(options = {}) {
            var $container = $('#events-mix');
                filters = [];

            mixer.configure(options);
            // $container.mixItUp('configure', options);

            // get filter groups
            filters = _self.getFilterGroups();
            console.log(filters);

            // permutations
            filters = _self.getFilterPermutations(filters);
            console.log(filters);

            // convert filters to string
            filters = filters.toString();
            console.log(filters);

            // empty filters
            if (!filters) {
                filters = 'all';
            }

            // active plugin mix
            mixer.filter(filters);
            // $container.mixItUp('filter', filters);
        },
        initMixItUp: function() {
            var $container = $('#events-mix'),
                hash = window.location.hash.replace('#', '');

            if (!$container.length)  return;

            if (!hash) {
                hash = 'all';
            } else {
                hash = '.' + hash;
            }

            // init
            mixer = Mixitup($container, {
                load: {
                    filter: hash
                },
                controls: {
                    enable: true
                },
                selectors: {
                    target: '.listing-list__item'
                },
                animation: {
                    enable: false,
                    duration: 200
                },
                callbacks: {
                    onMixStart: function (state) {
                        var $empty = $('#empty-listing');
                        $empty.hide();
                    },
                    onMixEnd: function (state) {
                        var $empty = $('#empty-listing');

                        if (state.hasFailed) {
                            $empty.show();
                        } else {
                            $empty.hide();
                        }
                    }
                }
            });

            console.log(mixer);

            _self.activateMixItUp();
        }
    };


    // -------------------
    // BINDS
    // -------------------

    _self.initMixItUp();

    // ---------------- toggle filters
    $('[data-filters-toggle]').on('click.events', function (event) {
        _self.toggleFilters($(this));
    });

    // ---------------- mix it up trigger
    $('[data-list-filter]').on('change.events', function (event) {
        _self.activateMixItUp({
            animation: {
                enable: true
            }
        });
    });

    return _self;
});
